<div *ngIf="loading" class="login-loader text-center"><img src="assets/images/filter/filter-loading.svg" alt="Loader" width="100" height="100" /></div>    
<div class="main-container" [ngClass] ="{ 'setDivopacity': loading }">   
    <div class="mcont-col-1"> 
        <div class="mcont-col-1">
            <div class="header-logo" ><span [style.background-image]="'url(' + headerLogo + ')'"></span></div>
            <div class="mcont-inner-div">
                <div class="mcont-inner-col" *ngIf="userIdFlag">
                    <div class="verify-div" *ngIf="!loading && verifiedOKFlag && emailResponseFlag">
                        <img class="verify-img" src="assets/images/login/unsubscribed-success.png">   
                        <p class="verify-text1 verify-text-ft-1">You've been unsubscribed. </p>                                        
                        <p class="verify-text verify-text-ft-2" [innerHTML]="responseMsg"></p>
                    </div>  
                    <div class="verify-div" *ngIf="!loading && !verifiedOKFlag && emailResponseFlag">
                        <img class="verify-img" src="assets/images/login/unsubscribed-success.png"> 
                        <!--p class="verify-text1 verify-text-ft-1">You've been unsubscribed.</p-->  
                        <p class="verify-text verify-text-ft-2" [innerHTML]="responseMsg"></p>                        
                    </div>                   
                </div>
                <div class="mcont-inner-col" *ngIf="!userIdFlag">
                    <div *ngIf="!emailResponseFlag" class="email-box">
                        <div class="mcont-inner-col">
                            <div class="heading">Unsubscribe</div>
                            <div class="label">Please reconfirm your email address</div> 
                            <div class="input-group" [ngClass]="{ 'active': emailInputFlag, 'error': emailErrorFlag }">
                                <div class="input-group-prepend email-img normal"  [ngClass]="{ 'active': emailInputFlag  }"></div>
                                <input tabindex="1" type="text" class="form-control inputtext" matInput placeholder="Enter Email" [(ngModel)]="emailId" maxlength="100" (keyup)="onKeypress($event)" (change)="checkEmailValition($event.target.value)" />                                                                 
                            </div> 
                            <div *ngIf="emailErrorFlag" class="login-invalid-feedback ">
                                <img src="assets/images/login/error-img.png" /> <span>{{emailErrorMsg}}</span>
                            </div>
                            <div class="em-sub" [ngClass]="{ 'setOpacity5' : mailDisableFlag }" (click)="sendEmail()">Submit</div>                              
                        </div>
                    </div>
                    <div class="verify-div" *ngIf="!loading && verifiedOKFlag && emailResponseFlag">
                        <img class="verify-img" src="assets/images/login/unsubscribed-success.png">   
                        <p class="verify-text1 verify-text-ft-1">You've been unsubscribed. </p>                                        
                        <p class="verify-text verify-text-ft-2" [innerHTML]="responseMsg"></p>
                    </div>  
                    <div class="verify-div" *ngIf="!loading && !verifiedOKFlag && emailResponseFlag">
                        <img class="verify-img" src="assets/images/login/unsubscribed-success.png"> 
                        <!--p class="verify-text1 verify-text-ft-1">You've been unsubscribed.</p-->  
                        <p class="verify-text verify-text-ft-2" [innerHTML]="responseMsg"></p>                        
                    </div>                   
                </div>              
            </div>
            <app-auth-footer></app-auth-footer>
        </div>
    </div>
    <div class="mcont-col-2" [style.height.px]="innerHeight">
        <app-auth-right-panel class="login-bg" ></app-auth-right-panel>
    </div>     
</div>  



